import React, { FC, memo, useCallback } from "react";
import { useTranslation } from "react-i18next";

import { WithMargin } from "../TopBar/styled";
import { SeveralIconToggle } from "../TopBar/SeveralIconToggle";
import { getNextSortType } from "./getNextSortType";

import { SortOrder } from "./types";

interface SortByDateProps {
  active: boolean;
  order: SortOrder;
  setSort: (sort: string) => void;
}

export const SortByDate: FC<SortByDateProps> = memo(({ active, order, setSort }) => {
  const { t } = useTranslation("catalog");

  const handleSort = useCallback(() => setSort(getNextSortType(order)), [order, setSort]);

  return (
    <WithMargin margin={"0 0 0 .75rem"}>
      <SeveralIconToggle
        icons={["time", order === SortOrder.ASC ? "sorting_asc" : "sorting_des"]}
        isSelected={active}
        onClick={handleSort}
        title={t("sortByUpdated")}
      />
    </WithMargin>
  );
});
